module.exports = __webpack_public_path__ + "img/kszqznn.518c10a8.jpg";